<template>
  <div class="wrapper-slide-modal">
    <button class="common-btn" @click="onButtonNext" :disabled="!activeButton">
      {{ data.buttonNext }}
    </button>
    <modal
      ref="slideModal"
      white-blur
      no-close-on-backdrop
      block-escape
      v-if="currentSlide && currentSlide.component !== 'Slide0'"
    >
      <template v-slot:content>
        <div :class="classModal">
          <img
            class="slide-modal__image"
            v-if="!isLastSlide"
            :src="getImageById(currentSlide.modal.image)"
          />
          <div>
            <voice-over
              bg-color="green-100"
              bg-color-hover="green-200"
              color-icon="black-100"
              :src="
                require(`@/assets/audios/vo/${currentSlide.modal.voiceOver}.mp3`)
              "
            ></voice-over>
            <h2
              class="slide-modal__title"
              tabindex="0"
              v-if="!isLastSlide && currentSlide.modal.title"
            >
              {{ currentSlide.modal.title }}
            </h2>
            <p class="slide-modal__description" tabindex="0">
              {{ currentSlide.modal.description }}
            </p>
            <div
              class="slide-modal-buttons"
              :class="{ 'slide-modal-buttons--last': isLastSlide }"
            >
              <button class="common-btn common-btn--secondary" @click="onBack">
                {{ data.buttonGoBack }}
              </button>
              <button class="common-btn" @click="onNextSlide">
                {{ !isLastSlide ? data.buttonNext : data.buttonBackToLab }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal, VoiceOver } from '@discoveryeducation/components';
import { computed, onMounted, ref, toRefs } from '@vue/composition-api';

export default {
  name: 'SlideModal',
  components: { Modal, VoiceOver },
  props: {
    activeButton: {
      type: Boolean,
      default: false,
    },
    currentSlide: {
      type: Object,
    },
  },
  setup(props, { root, emit }) {
    const slideModal = ref(null);
    const isLastSlide = ref(false);
    const isFirstSlide = ref(false);
    const { currentSlide } = toRefs(props);

    onMounted(() => {
      isFirstSlide.value = currentSlide.value.component === 'Slide1';
      isLastSlide.value = currentSlide.value.component === 'Slide4';
    });

    const showModal = () => slideModal.value.show();

    const onButtonNext = () => {
      root.getAudioById('button-click').play();
      emit('on-button-next');
    };

    const onNextSlide = () => {
      if (!isLastSlide.value) {
        emit('on-hide-modal', { isNext: true });
      } else {
        root.onSwapComponent('IntroPage');
      }
      slideModal.value.hide();
    };

    const onBack = () => {
      emit('on-hide-modal', { isNext: false });
      slideModal.value.hide();
    };

    const classModal = computed(() => {
      let clazz = {
        'slide-modal': true,
        'slide-modal--first': isFirstSlide.value,
        'slide-modal--last': isLastSlide.value,
      };
      return { ...clazz };
    });

    return {
      slideModal,
      isLastSlide,
      showModal,
      onButtonNext,
      onNextSlide,
      onBack,
      classModal,
    };
  },
};
</script>

<style lang="stylus" scoped>

color-white = colors.white
color-black-100 = colors.black-100
color-black-200 = colors.black-200

.slide-modal
  background-color color-white
  padding 60px 70px 65px
  width 1097px
  height 540px
  border-radius radius-modal
  box-shadow modal-shadow
  display flex
  align-items center

  &--last
    padding 65px
    width 980px

  &--first
    height 750px

  &__title
    font-size 40px
    color color-black-100
    font-family Nunito-Bold
    line-height 54px
    margin-bottom 10px

  &__description
    font-size 24px
    line-height 32px
    letter-spacing 0.6px
    color color-black-200
    min-height 160px
    white-space pre-line

  &__image
    width 374px
    height 374px
    margin-right 92px

  &-buttons
    width 480px
    margin-top 27px
    display flex
    align-items center
    justify-content space-between

    &--last
      width 469px
      margin-top 68px
      margin-left 380px

&::v-deep
  .button--play-audio
    border-radius radius-audio
    margin-top 10px
    margin-bottom 25px
</style>
